// src/CircleIcon.tsx
import { jsx } from "react/jsx-runtime";
var CircleIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "10" })
  }
);
var CircleIcon_default = CircleIcon;

export {
  CircleIcon_default
};
